var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsArray, IsDateString, IsObject, IsPositive, IsString, IsUUID } from 'class-validator';
export class OfficeProductLineItemFullSizeDto {
    id;
    createdAt;
    updatedAt;
    title;
    count;
    officeProductId;
    officeProduct;
    officeProductAssignmentLineItems;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeProductLineItemFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeProductLineItemFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeProductLineItemFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeProductLineItemFullSizeDto.prototype, "title", void 0);
__decorate([
    Expose(),
    IsPositive(),
    __metadata("design:type", Number)
], OfficeProductLineItemFullSizeDto.prototype, "count", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], OfficeProductLineItemFullSizeDto.prototype, "officeProductId", void 0);
__decorate([
    Expose(),
    IsObject(),
    __metadata("design:type", Function)
], OfficeProductLineItemFullSizeDto.prototype, "officeProduct", void 0);
__decorate([
    IsArray(),
    Expose(),
    __metadata("design:type", Array)
], OfficeProductLineItemFullSizeDto.prototype, "officeProductAssignmentLineItems", void 0);
//# sourceMappingURL=custom-office-product-line-item.full-size.dto.js.map